<template>
  <div
    :class="[
      'collection-detail-info__container',
      !isListViewStyle && 'collection-detail-info__container-block',
    ]"
  >
    <Difficulty
      :class="[
        'collection-detail-info__difficulty',
        'collection-detail-info__item-with-separator',
      ]"
      :difficulty="collection.difficulty"
      :alwaysVisible="true"
      uppercase
    />
    <div :class="['collection-detail-info__learning-area-list']">
      <LearningAreaLabel
        v-for="name in learningAreaNames"
        :key="`${name}-la`"
        :class="['collection-detail-info__learning-area']"
        :learningArea="name"
        uppercase
      />
    </div>
  </div>
</template>

<script>
import LearningAreaLabel from '@/components/properties/LearningAreaLabel.vue'
import Difficulty from '@/components/properties/Difficulty.vue'
export default {
  name: 'CollectionDetailInfo',
  components: {
    LearningAreaLabel,
    Difficulty,
  },
  props: {
    isListViewStyle: {
      type: Boolean,
      required: true,
    },
    collection: {
      type: Object,
      required: true,
    },
    learningAreaNames: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.collection-detail-info {
  &__container {
    display: flex;

    &-block {
      @include tablet {
        height: 70px;
      }
    }
  }
  &__difficulty {
    width: fit-content !important;
    text-transform: uppercase !important;
  }
  &__learning-area-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__learning-area {
    white-space: nowrap;
  }

  &__item-with-separator:not(:last-child)::after {
    content: ' ';
    width: 1px;
    height: 28px;
    opacity: 0.5;
    background: #fff;
    margin: 0 10px;

    @include tablet {
      height: 44px;
    }
  }
}
</style>
